/* @ngInject */
const search = (
  $filter,
  utils,
  valueHandler
) => {
  /**
   * Remove all item which doesn't match with the local search
   * @param _items An array of all items you want to search in
   * @param _search The string for testing if it's match
   **/
  return (_items, _search) => {
    if (valueHandler.isEmpty(_items) || valueHandler.isEmpty(_search)) {
      return _items
    }

    const filtered = []
    for (let i = 0; i < _items.length; i++) {
      const item = _items[i]

      utils.forEach(item, (value, key) => {
        if (!valueHandler.isNull(value)) {
          const formatValue = $filter('field')(value, key)
          if (value.toString().toLowerCase().indexOf(_search.toLowerCase()) !== -1 ||
            formatValue.toString().toLowerCase().indexOf(_search.toLowerCase()) !== -1) {
            if (filtered.indexOf(item) === -1) {
              filtered.push(item)
            }
          }
        }
      })
    }
    return filtered
  }
}

export default search



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/entities/search.filter.js